import { ErrorDialogComponent } from './../error-dialog/error-dialog.component';
import { RespCenter } from './../models/resp-center.model';
import { DataService } from './../services/data.service';
import { ChargingProject } from './../models/charging-project.model';
import { MatDialog } from '@angular/material/dialog';
import { MatchingProjectDialogComponent } from './../matching-project-dialog/matching-project-dialog.component';
import { Router } from '@angular/router';
import { ProjectDataService } from './../services/project-data.service';
import { Component, OnInit } from '@angular/core';
import { StateOption } from '../models/state-option.model';
import { MajorLocation } from '../models/major-location.model';
import { OperatingUnit } from '../models/operating-unit.model';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-funding-project',
  templateUrl: './funding-project.component.html',
  styleUrls: ['./funding-project.component.scss'],
  standalone: false,
})
export class FundingProjectComponent implements OnInit {
  state: StateOption;
  businessUnit: string;
  fundingProjectID: string;
  projectName: string;
  operatingUnit: OperatingUnit;
  projectManager: string;
  projectManagerID: string;
  projectLongDescription: string;
  problemStatement: string;
  proposedObjective: string;
  notes: string;
  matchingProjects: ChargingProject[];
  ecosysDataLoaded: boolean;
  businessUnitOptions: string[];
  stateOptions: StateOption[];
  projectNameOptions: string[];
  loadingStateAndBusinessUnitOptions: boolean;
  stateAndBusinessUnitLoaded: boolean;
  projectDataLoaded: boolean;
  changesMade: boolean;
  fundingProjectType: string;
  respCenter: RespCenter;
  errorShowing: boolean;
  statusError: boolean;
  operatingUnitOptions: OperatingUnit[];
  unfilteredOperatingUnitOptions: OperatingUnit[];

  constructor(
    private projectDataService: ProjectDataService,
    private router: Router,
    private dialog: MatDialog,
    private dataService: DataService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    //remove this
    /*this.projectDataService.projectData = new ProjectData();

    this.getProjectDataFromService();
    this.getMatchingProjects();*/
    this.errorShowing = false;
    this.statusError = false;
    this.loadFundingProjectData();
    if (this.unfilteredOperatingUnitOptions.length === 0) {
      this.loadOperatingUnitFile();
    }
    this.matchUpOperatingUnit();
    this.changesMade = false;
    if (!this.projectDataService.ecosysData || this.projectDataService.ecosysData.length === 0) {
      this.getEcosysData();
    }
    this.loadingStateAndBusinessUnitOptions = false;
  }

  getEcosysData() {
    this.dataService.getEcosysData().subscribe(
      (result) => {
        this.projectDataService.ecosysData = result.CostObjectList;
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Ecosys Data Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Ecosys Data Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        const dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  getStateAndBusinessUnitOptions() {
    this.changesMade = true;
    this.loadingStateAndBusinessUnitOptions = true;
    this.projectDataLoaded = false;
    this.stateAndBusinessUnitLoaded = false;
    this.state = null;
    this.businessUnit = '';
    this.businessUnitOptions = [];
    this.stateOptions = [];
    this.projectName = '';
    this.operatingUnit = null;
    this.projectManager = '';
    this.projectManagerID = '';
    this.projectLongDescription = '';
    this.proposedObjective = '';
    this.problemStatement = '';
    this.notes = '';
    const callBody = {
      fundProjId: this.fundingProjectID,
    };
    this.errorShowing = false;
    this.statusError = false;
    this.dataService.getAthenaData('state_busi_ch', callBody).subscribe(
      (result) => {
        if (result == '[][]') {
          this.errorShowing = true;
        }
        const startOfStateChoices = this.parseForBusinessUnit(JSON.stringify(result));
        if (startOfStateChoices != -1) {
          this.parseForState(JSON.stringify(result).substring(startOfStateChoices));
          this.loadingStateAndBusinessUnitOptions = false;
          this.stateAndBusinessUnitLoaded = true;
        } else {
          this.loadingStateAndBusinessUnitOptions = false;
        }
      },
      (error) => {
        console.log('error', error);
        this.loadingStateAndBusinessUnitOptions = false;
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get State and Bus Unit Options Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get State and Bus Unit Options Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        const dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  closeErrorMessage() {
    this.errorShowing = false;
    this.statusError = false;
  }

  parseForBusinessUnit(arrayString: string): number {
    let i = 2;
    let firstTime = true;
    while (arrayString[i] !== ']' && !this.statusError) {
      const iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      const businessUnitEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      if (firstTime) {
        if (JSON.parse(businessUnitEntry).status !== '2') {
          this.statusError = true;
        }
        firstTime = false;
      }
      if (!this.statusError) {
        this.businessUnitOptions.push(JSON.parse(businessUnitEntry).businessunit.trim());
        while (arrayString[i] !== ']' && arrayString[i] !== '{') {
          i++;
        }
      }
    }
    if (!this.statusError) {
      if (this.businessUnitOptions.length == 1) {
        this.businessUnit = this.businessUnitOptions[0];
        this.filterOperatingUnitByBusinessUnit();
      }
    }
    if (this.statusError) {
      return -1;
    } else {
      return i + 1;
    }
  }

  filterOperatingUnitByBusinessUnit() {
    this.operatingUnitOptions = [];
    for (let i = 0; i < this.unfilteredOperatingUnitOptions.length; i++) {
      if (this.unfilteredOperatingUnitOptions[i].BUSINESS_UNIT === this.businessUnit) {
        this.operatingUnitOptions.push(this.unfilteredOperatingUnitOptions[i]);
      }
    }
  }

  parseForState(arrayString: string): number {
    let i = 1;
    while (arrayString[i] !== ']') {
      const iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      const stateEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      const entryParse = JSON.parse(stateEntry);
      this.stateOptions.push(
        new StateOption(
          entryParse.state.trim(),
          entryParse.majorlocation.trim(),
          entryParse.major_loc_id.trim()
        )
      );
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    if (this.stateOptions.length == 1) {
      this.state = this.stateOptions[0];
      this.stateSelected(this.state);
      if (this.businessUnit && this.state) {
        this.getProjectData();
      }
    }
    return i + 1;
  }

  parseForRespCenter(arrayString: string) {
    let i = 1;
    while (arrayString[i] !== ']') {
      const iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      const respCenterEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      const entryParse = JSON.parse(respCenterEntry);
      this.respCenter = new RespCenter(
        entryParse.resp_center.trim(),
        entryParse.description.trim()
      );
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
  }

  parseForProjectManagerID(arrayString: string) {
    let i = 1;
    while (arrayString[i] !== ']') {
      const iStart = i;
      while (arrayString[i] !== '}' || arrayString[i + 1] !== ']') {
        i++;
      }
      const projectManagerIDEntry = arrayString
        .substring(iStart, i + 2)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      const entryParse = JSON.parse(projectManagerIDEntry);
      if (entryParse[0].proj_mgr) {
        this.projectManagerID = entryParse[0].proj_mgr.trim();
      }
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    return i + 1;
  }

  parseForProjectManager(arrayString: string) {
    let i = 1;
    while (arrayString[i] !== ']') {
      const iStart = i;
      while (arrayString[i] !== '}' || arrayString[i + 1] !== ']') {
        i++;
      }
      const projectManagerEntry = arrayString
        .substring(iStart, i + 2)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      const entryParse = JSON.parse(projectManagerEntry);
      if (entryParse[0].prj_mgr_name) {
        this.projectManager = entryParse[0].prj_mgr_name.trim();
      }
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    return i + 1;
  }

  parseForLongDescription(arrayString: string) {
    let i = 1;
    while (arrayString[i] !== ']') {
      const iStart = i;
      while (arrayString[i] !== '}' || arrayString[i + 1] !== ']') {
        i++;
      }
      const longDescriptionEntry = arrayString
        .substring(iStart, i + 2)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      const entryParse = JSON.parse(longDescriptionEntry);
      if (entryParse[0].long_description) {
        this.projectLongDescription = entryParse[0].long_description.trim();
      }
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    return i + 1;
  }

  parseForNotes(arrayString: string) {
    let i = 1;
    while (arrayString[i] !== ']') {
      const iStart = i;
      while (arrayString[i] !== '}' || arrayString[i + 1] !== ']') {
        i++;
      }
      const notesEntry = arrayString
        .substring(iStart, i + 2)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      const entryParse = JSON.parse(notesEntry);
      if (entryParse[0].notes) {
        this.notes = entryParse[0].notes.trim();
      }
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    return i + 1;
  }

  parseForFundingProjectType(arrayString: string) {
    let i = 1;
    while (arrayString[i] !== ']') {
      const iStart = i;
      while (arrayString[i] !== '}' || arrayString[i + 1] !== ']') {
        i++;
      }
      const fundingProjectTypeEntry = arrayString
        .substring(iStart, i + 2)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      const entryParse = JSON.parse(fundingProjectTypeEntry);
      if (entryParse[0].fp_type) {
        this.fundingProjectType = entryParse[0].fp_type.trim();
      }
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    return i + 1;
  }

  parseForProjectName(arrayString: string): number {
    let i = 2;
    while (arrayString[i] !== ']') {
      const iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      const projectNameEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      this.projectName = JSON.parse(projectNameEntry).projectname.trim();
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    return i + 1;
  }

  parseForOperatingUnit(arrayString: string): number {
    let i = 1;
    while (arrayString[i] !== ']') {
      const iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      const operatingUnitEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      const operatingUnitValue = JSON.parse(operatingUnitEntry).value.trim().substring(0, 4);
      for (let i = 0; i < this.operatingUnitOptions.length; i++) {
        if (this.operatingUnitOptions[i].OPERATING_UNIT === operatingUnitValue) {
          this.operatingUnit = this.operatingUnitOptions[i];
        }
      }
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    return i + 1;
  }

  topSectionPopulated() {
    return this.fundingProjectID && this.state && this.businessUnit;
  }

  getProjectDataFromService() {
    //this.state = this.projectDataService.projectData.state;
    this.businessUnit = this.projectDataService.projectData.businessUnit;
    this.fundingProjectID = this.projectDataService.projectData.fundingProjectID;
    this.projectName = this.projectDataService.projectData.projectName;
    //this.operatingUnit = this.projectDataService.projectData.operatingUnit;
    this.projectManager = this.projectDataService.projectData.projectManager;
    this.projectLongDescription = this.projectDataService.projectData.projectLongDescription;
    this.problemStatement = this.projectDataService.projectData.problemStatement;
    this.proposedObjective = this.projectDataService.projectData.proposedObjective;
    this.notes = this.projectDataService.projectData.notes;
  }

  getProjectData() {
    if (this.state && this.businessUnit) {
      this.clearProjectDataSubset();
      const callBody = {
        fundProjId: this.fundingProjectID,
        businessUnit: this.businessUnit,
      };
      this.dataService.getAthenaData('prjname_opunit', callBody).subscribe(
        (result) => {
          const startOfOperatingUnit = this.parseForProjectName(JSON.stringify(result));
          const startOfRespCenter = this.parseForOperatingUnit(
            JSON.stringify(result).substring(startOfOperatingUnit)
          );
          this.parseForRespCenter(
            JSON.stringify(result).substring(startOfOperatingUnit + startOfRespCenter)
          );
          this.findEcosysMatch();
          //this.projectDataLoaded = true;
        },
        (error) => {
          console.log('error', error);
          let errorType = '';
          let errorDescription = '';
          if (error.error.message) {
            errorDescription = errorDescription.concat(
              'Get Project Data Error - ',
              error.error.message
            );
          } else {
            errorDescription = errorDescription.concat('Get Project Data Error');
          }
          errorType = errorType.concat(error.status, ' ', error.statusText);
          const dataStructure = {
            errorType: errorType,
            errorDescription: errorDescription,
          };
          this.dialog.open(ErrorDialogComponent, {
            data: dataStructure,
            disableClose: true,
          });
        }
      );
    }
  }

  stateSelected(stateOption: StateOption) {
    sessionStorage.setItem(
      'fundingProjectMajorLocation',
      JSON.stringify(new MajorLocation(stateOption.majorlocation, stateOption.major_loc_id))
    );
  }

  findEcosysMatch() {
    let matchFound = false;
    for (let i = 0; i < this.projectDataService.ecosysData.length && !matchFound; i++) {
      const entry = this.projectDataService.ecosysData[i];
      if (
        entry.CostObjectID.trim() == this.fundingProjectID.trim() &&
        entry.State.trim() == this.state.state
      ) {
        matchFound = true;
        this.projectManager = entry.ProjectManagerName;
        this.projectManagerID = entry.ProjectManagerID;
        this.projectLongDescription = entry.ProjectScopeStatement;
        this.problemStatement = entry.OpportunityThreatStatement;
        this.proposedObjective = entry.Objective;
        this.notes = entry.PhysicalAddress;
        this.fundingProjectType = entry.ProjectType;
        this.projectDataLoaded = true;
      }
    }
    if (!matchFound) {
      const callBody = {
        businessUnit: this.businessUnit,
        fundProjId: this.fundingProjectID,
      };
      this.dataService.getAthenaData('prjmgr_pldesc_notes_fptype', callBody).subscribe(
        (result) => {
          const startOfProjectManager = this.parseForProjectManagerID(JSON.stringify(result));
          const startOfLongDescription = this.parseForProjectManager(
            JSON.stringify(result).substring(startOfProjectManager - 1)
          );
          const startOfNotes = this.parseForLongDescription(
            JSON.stringify(result).substring(startOfProjectManager + startOfLongDescription - 2)
          );
          const startOfFundingProjectType = this.parseForNotes(
            JSON.stringify(result).substring(
              startOfProjectManager + startOfLongDescription + startOfNotes - 3
            )
          );
          this.parseForFundingProjectType(
            JSON.stringify(result).substring(
              startOfProjectManager +
                startOfLongDescription +
                startOfNotes +
                startOfFundingProjectType -
                4
            )
          );
          this.problemStatement = '';
          this.proposedObjective = '';
          this.projectDataLoaded = true;
        },
        (error) => {
          console.log('error', error);
          let errorType = '';
          let errorDescription = '';
          if (error.error.message) {
            errorDescription = errorDescription.concat(
              'PowerPlan Suppliment Error - ',
              error.error.message
            );
          } else {
            errorDescription = errorDescription.concat('PowerPlan Suppliment Error');
          }
          errorType = errorType.concat(error.status, ' ', error.statusText);
          const dataStructure = {
            errorType: errorType,
            errorDescription: errorDescription,
          };
          this.dialog.open(ErrorDialogComponent, {
            data: dataStructure,
            disableClose: true,
          });
        }
      );
    }
  }

  clearProjectData() {
    this.projectName = '';
    this.operatingUnit = null;
    this.projectManager = '';
    this.projectManagerID = '';
    this.projectLongDescription = '';
    this.problemStatement = '';
    this.proposedObjective = '';
    this.notes = '';
    this.state = null;
    this.businessUnit = '';
    this.fundingProjectType = '';
    this.dataService.fundingProjectMajorLocation = null;
    this.stateAndBusinessUnitLoaded = false;
    this.projectDataLoaded = false;
  }

  clearProjectDataSubset() {
    this.projectName = '';
    this.operatingUnit = null;
    this.projectManager = '';
    this.projectManagerID = '';
    this.projectLongDescription = '';
    this.problemStatement = '';
    this.proposedObjective = '';
    this.notes = '';
    this.fundingProjectType = '';
    this.projectDataLoaded = false;
  }

  startOver() {
    //this.state = '';
    this.businessUnit = '';
    this.fundingProjectID = '';
    this.clearProjectData();
  }

  exitPage() {
    this.clearSessionProjectData();
    this.router.navigate(['/dashboard']);
  }

  confirmAndContinue() {
    this.saveFundingProjectData();
    this.router.navigate(['/charging-project-setup']);
  }

  saveFundingProjectData() {
    sessionStorage.setItem('state', JSON.stringify(this.state));
    sessionStorage.setItem('businessUnit', this.businessUnit);
    sessionStorage.setItem('fundingProjectID', this.fundingProjectID);
    sessionStorage.setItem('projectName', this.projectName);
    sessionStorage.setItem('operatingUnit', JSON.stringify(this.operatingUnit));
    sessionStorage.setItem('projectManager', this.projectManager);
    sessionStorage.setItem('projectManagerID', this.projectManagerID);
    sessionStorage.setItem('projectLongDescription', this.projectLongDescription);
    sessionStorage.setItem('problemStatement', this.problemStatement);
    sessionStorage.setItem('proposedObjective', this.proposedObjective);
    sessionStorage.setItem('notes', this.notes);
    sessionStorage.setItem('stateOptions', JSON.stringify(this.stateOptions));
    sessionStorage.setItem('businessUnitOptions', JSON.stringify(this.businessUnitOptions));
    sessionStorage.setItem('fundingProjectType', this.fundingProjectType);
    sessionStorage.setItem('fundingProjectRespCenter', JSON.stringify(this.respCenter));
    sessionStorage.setItem('operatingUnitOptions', JSON.stringify(this.operatingUnitOptions));
    sessionStorage.setItem(
      'unfilteredOperatingUnitOptions',
      JSON.stringify(this.unfilteredOperatingUnitOptions)
    );
    if (this.changesMade) {
      this.clearFutureSessionStorage();
    }
  }

  clearSessionProjectData() {
    sessionStorage.removeItem('state');
    sessionStorage.removeItem('businessUnit');
    sessionStorage.removeItem('fundingProjectID');
    sessionStorage.removeItem('projectName');
    sessionStorage.removeItem('operatingUnit');
    sessionStorage.removeItem('projectManager');
    sessionStorage.removeItem('projectManagerID');
    sessionStorage.removeItem('projectLongDescription');
    sessionStorage.removeItem('problemStatement');
    sessionStorage.removeItem('proposedObjective');
    sessionStorage.removeItem('notes');
    sessionStorage.removeItem('stateOptions');
    sessionStorage.removeItem('businessUnitOptions');
    sessionStorage.removeItem('fundingProjectType');
    this.clearFutureSessionStorage();
  }

  clearFutureSessionStorage() {
    sessionStorage.removeItem('chargingProjectName');
    sessionStorage.removeItem('estimatedStartDate');
    sessionStorage.removeItem('estimatedInServiceDate');
    sessionStorage.removeItem('powerPlanProjectType');
    sessionStorage.removeItem('majorLocation');
    sessionStorage.removeItem('projectChargeIndicator');
    sessionStorage.removeItem('respCenter');
    sessionStorage.removeItem('contractAdmin');
    sessionStorage.removeItem('assetLocation');
    sessionStorage.removeItem('chargingProjectLongDescription');
    sessionStorage.removeItem('majorLocationOptions');
    sessionStorage.removeItem('contractAdminOptions');
    sessionStorage.removeItem('additionalMajorLocations');
    sessionStorage.removeItem('assetLocationOptions');
    sessionStorage.removeItem('workOrderTypeOptions');
    sessionStorage.removeItem('longDescriptionComplete');
    sessionStorage.removeItem('longDescriptionSubmitted');
  }

  loadFundingProjectData() {
    this.fundingProjectID = sessionStorage.getItem('fundingProjectID');
    this.projectName = sessionStorage.getItem('projectName');
    const operatingUnitCheck = sessionStorage.getItem('operatingUnit');
    this.projectManager = sessionStorage.getItem('projectManager');
    this.projectManagerID = sessionStorage.getItem('projectManagerID');
    this.projectLongDescription = sessionStorage.getItem('projectLongDescription');
    this.problemStatement = sessionStorage.getItem('problemStatement');
    this.proposedObjective = sessionStorage.getItem('proposedObjective');
    this.notes = sessionStorage.getItem('notes');
    this.fundingProjectType = sessionStorage.getItem('fundingProjectType');
    const respCenterCheck = sessionStorage.getItem('fundingProjectRespCenter');
    if (operatingUnitCheck) {
      this.operatingUnit = JSON.parse(operatingUnitCheck);
    } else {
      this.operatingUnit = null;
    }
    const unfilteredOperatingUnitOptionsCheck = sessionStorage.getItem(
      'unfilteredOperatingUnitOptions'
    );
    if (unfilteredOperatingUnitOptionsCheck) {
      this.unfilteredOperatingUnitOptions = [];
      this.unfilteredOperatingUnitOptions = JSON.parse(unfilteredOperatingUnitOptionsCheck);
    } else {
      this.unfilteredOperatingUnitOptions = [];
    }
    const operatingUnitOptionsCheck = sessionStorage.getItem('operatingUnitOptions');
    if (operatingUnitOptionsCheck) {
      this.operatingUnitOptions = [];
      this.operatingUnitOptions = JSON.parse(operatingUnitOptionsCheck);
    } else {
      this.operatingUnitOptions = [];
    }
    if (respCenterCheck) {
      this.respCenter = JSON.parse(respCenterCheck);
    } else {
      this.respCenter = null;
    }
    const stateOptionsCheck = sessionStorage.getItem('stateOptions');
    if (stateOptionsCheck) {
      this.stateOptions = [];
      this.stateOptions = JSON.parse(stateOptionsCheck);
    } else {
      this.stateOptions = [];
    }
    const businessUnitOptionsCheck = sessionStorage.getItem('businessUnitOptions');
    if (businessUnitOptionsCheck) {
      this.businessUnitOptions = [];
      this.businessUnitOptions = JSON.parse(businessUnitOptionsCheck);
    } else {
      this.businessUnitOptions = [];
    }
    const stateCheck = sessionStorage.getItem('state');
    if (stateCheck) {
      this.state = JSON.parse(stateCheck);
    } else {
      this.state = null;
    }
    this.businessUnit = sessionStorage.getItem('businessUnit');
    if (this.state && this.businessUnit) {
      this.stateAndBusinessUnitLoaded = true;
      this.projectDataLoaded = true;
    } else {
      this.stateAndBusinessUnitLoaded = false;
      this.projectDataLoaded = false;
    }
  }

  compareState(o1: any, o2: any): boolean {
    if (!o1 || !o2) {
      return false;
    }
    return (
      o1.state == o2.state &&
      o1.major_loc_id == o2.major_loc_id &&
      o1.majorlocation == o2.majorlocation
    );
  }

  getMatchingProjects() {
    this.matchingProjects = [
      {
        status: 'MMAPS In Process',
        chargingProjectID: '000000000',
        projectType: 'Project type info goes here(35 max)',
        projectName: 'Project name goes here (70 char.max) loerm ipsum dolor isit shuctus.',
        majorLocation: 'Project type info goes here (35 max) lore Ipsum',
        projectChargeIndicator: 'Project charge indicator 35 max)',
        assetLocation:
          'The character max is 254. Use text overflow in case of long entries Lorem ipsum',
        respCenter: '1234',
        contractAdmin: 'LAN ID (25 char. max)',
        activityIDs: ['000000000', '000000000', '000000000'],
      },
      {
        status: 'In PowerPlan',
        chargingProjectID: '000000000',
        projectType: 'Project type info goes here(35 max)',
        projectName: 'Project name goes here (70 char.max) loerm ipsum dolor isit shuctus.',
        majorLocation: 'Project type info goes here (35 max) lore Ipsum',
        projectChargeIndicator: 'Project charge indicator 35 max)',
        assetLocation:
          'The character max is 254. Use text overflow in case of long entries Lorem ipsum',
        respCenter: '1234',
        contractAdmin: 'LAN ID (25 char. max)',
        activityIDs: ['000000000', '000000000', '000000000'],
      },
      {
        status: 'MMAPS Active',
        chargingProjectID: '000000000',
        projectType: 'Project type info goes here(35 max)',
        projectName: 'Project name goes here (70 char.max) loerm ipsum dolor isit shuctus.',
        majorLocation: 'Project type info goes here (35 max) lore Ipsum',
        projectChargeIndicator: 'Project charge indicator 35 max)',
        assetLocation:
          'The character max is 254. Use text overflow in case of long entries Lorem ipsum',
        respCenter: '1234',
        contractAdmin: 'LAN ID (25 char. max)',
        activityIDs: ['000000000', '000000000', '000000000'],
      },
      {
        status: 'MMAPS Active',
        chargingProjectID: '000000000',
        projectType: 'Project type info goes here(35 max)',
        projectName: 'Project name goes here (70 char.max) loerm ipsum dolor isit shuctus.',
        majorLocation: 'Project type info goes here (35 max) lore Ipsum',
        projectChargeIndicator: 'Project charge indicator 35 max)',
        assetLocation:
          'The character max is 254. Use text overflow in case of long entries Lorem ipsum',
        respCenter: '1234',
        contractAdmin: 'LAN ID (25 char. max)',
        activityIDs: ['000000000', '000000000', '000000000'],
      },
    ];
  }

  openMatchingProjects() {
    this.dialog.open(MatchingProjectDialogComponent, {
      data: this.matchingProjects,
      disableClose: true,
      width: '77.563rem',
      height: '32.563rem',
    });
  }

  loadOperatingUnitFile() {
    this.http.get('assets/operating-units.json').subscribe(
      (result) => {
        this.unfilteredOperatingUnitOptions = result as OperatingUnit[];
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat('Load OU File Error - ', error.error.message);
        } else {
          errorDescription = errorDescription.concat('Load OU File Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        const dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  matchUpOperatingUnit() {
    if (this.operatingUnit && this.operatingUnitOptions.length > 0) {
      for (let i = 0; i < this.operatingUnitOptions.length; i++) {
        if (this.operatingUnit.OPERATING_UNIT === this.operatingUnitOptions[i].OPERATING_UNIT) {
          this.operatingUnit = this.operatingUnitOptions[i];
        }
      }
    }
  }
}
